import { connect, type FormikFormProps } from 'formik'

import { FormStyled } from './styles/FormStyled'

export const FormContent = connect<FormikFormProps>(
  ({ formik: { handleReset, handleSubmit }, ...props }) => (
    <FormStyled onReset={handleReset} onSubmit={handleSubmit} {...props} />
  )
)
FormContent.displayName = 'Form.Content'
